"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHOW_DRAWER = exports.RESET_DRAWER = exports.HIDE_DRAWER = exports.DRAWER_STATE_SHOW = exports.DRAWER_STATE_NOSTACK = exports.DRAWER_STATE_HIDE = exports.DRAWER_STATE_HIDDEN = exports.CREATE_DRAWER = void 0;
exports["default"] = drawerReducer;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2["default"])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
} // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var CREATE_DRAWER = 'CREATE_DRAWER';
exports.CREATE_DRAWER = CREATE_DRAWER;
var SHOW_DRAWER = 'SHOW_DRAWER';
exports.SHOW_DRAWER = SHOW_DRAWER;
var HIDE_DRAWER = 'HIDE_DRAWER';
exports.HIDE_DRAWER = HIDE_DRAWER;
var RESET_DRAWER = 'RESET_DRAWER';
exports.RESET_DRAWER = RESET_DRAWER;
var DRAWER_STATE_NOSTACK = 0;
exports.DRAWER_STATE_NOSTACK = DRAWER_STATE_NOSTACK;
var DRAWER_STATE_SHOW = 1;
exports.DRAWER_STATE_SHOW = DRAWER_STATE_SHOW;
var DRAWER_STATE_HIDE = 2;
exports.DRAWER_STATE_HIDE = DRAWER_STATE_HIDE;
var DRAWER_STATE_HIDDEN = 3;
exports.DRAWER_STATE_HIDDEN = DRAWER_STATE_HIDDEN;

var drawerIsVisible = function drawerIsVisible(drawer) {
  return drawer && drawer.state === DRAWER_STATE_SHOW;
};

var resolve = {
  CREATE_DRAWER: function CREATE_DRAWER(oldDrawerStack, _ref) {
    var id = _ref.id,
        _ref$parentId = _ref.parentId,
        parentId = _ref$parentId === void 0 ? '' : _ref$parentId;
    var drawerStack = new Map(oldDrawerStack);
    drawerStack.set(id, {
      id: id,
      parentId: parentId,
      openChildId: '',
      state: DRAWER_STATE_HIDDEN
    });
    return drawerStack;
  },
  SHOW_DRAWER: function SHOW_DRAWER(oldDrawerStack, _ref2) {
    var id = _ref2.id;
    var drawerStack = new Map(oldDrawerStack);
    var drawer = drawerStack.get(id);
    var parentDrawer = drawerStack.get(drawer.parentId);

    if (parentDrawer) {
      if (parentDrawer.openChildId) {
        drawerStack = resolve.HIDE_DRAWER(drawerStack, {
          id: parentDrawer.openChildId
        });
        parentDrawer = drawerStack.get(drawer.parentId);
      }

      drawerStack.set(parentDrawer.id, _objectSpread(_objectSpread({}, parentDrawer), {}, {
        openChildId: id
      }));
    }

    drawer.state = DRAWER_STATE_SHOW;
    return drawerStack;
  },
  HIDE_DRAWER: function HIDE_DRAWER(oldDrawerStack, _ref3) {
    var id = _ref3.id;
    var drawerStack = new Map(oldDrawerStack);
    var drawer = drawerStack.get(id);
    var childDrawer = drawerStack.get(drawer.openChildId);

    if (drawerIsVisible(childDrawer)) {
      // Hide all child drawers
      drawerStack = resolve.HIDE_DRAWER(drawerStack, {
        id: childDrawer.id
      });
      drawer = drawerStack.get(id);
    }

    var parentDrawer = drawerStack.get(drawer.parentId);

    if (parentDrawer) {
      drawerStack.set(parentDrawer.id, _objectSpread(_objectSpread({}, parentDrawer), {}, {
        openChildId: ''
      }));
    }

    drawer.state = DRAWER_STATE_HIDE;
    return drawerStack;
  },
  RESET_DRAWER: function RESET_DRAWER(oldDrawerStack, _ref4) {
    var id = _ref4.id;
    var drawerStack = new Map(oldDrawerStack);
    var drawer = drawerStack.get(id);
    drawer.state = DRAWER_STATE_HIDDEN;
    return drawerStack;
  }
};

function drawerReducer(drawerStack, action) {
  if (!resolve[action.type]) {
    throw new Error("Wrong action type: ".concat(action.type, "."));
  }

  if (!action.id) {
    throw new Error("Every DrawerStack action requires a drawer id.");
  }

  return resolve[action.type](drawerStack, action);
}